import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

export default new Router({
	mode: 'history',
	routes: [
		{
		    path: '/login',
		    name: '登录',
			meta:{
				title: '登录'
			},
			component: resolve=>require(['@/view/home/Login'] , resolve)
		},
		{
			path: '/',
			name: '知言知礼',
			meta:{
				title: '知言知礼'
			},
			component: resolve=>require(['@/view/home/Index'] , resolve)
		},
		{
			path: '/index',
			name: '知言知礼',
			meta:{
				title: '知言知礼'
			},
			component: resolve=>require(['@/view/home/Index'] , resolve)
		},
		{
			path: '/index/framework',
			name: '成员管理',
			meta:{
				title: '成员管理'
			},
			component: resolve=>require(['@/view/home/framework/Index'] , resolve)
		},
		{
			path: '/index/router',
			name: '路由管理',
			meta:{
				title: '路由管理'
			},
			component: resolve=>require(['@/view/home/router/Index'] , resolve)
		},
		{
			path: '/index/auth',
			name: '角色管理',
			meta:{
				title: '角色管理'
			},
			component: resolve=>require(['@/view/home/auth/Index'] , resolve)
		},
		{
			path: '/index/log',
			name: '日志管理',
			meta:{
				title: '日志管理'
			},
			component: resolve=>require(['@/view/home/log/Index'] , resolve)
		},
		{
			path: '/index/sms',
			name: '短信管理',
			meta:{
				title: '短信管理'
			},
			component: resolve=>require(['@/view/home/sms/Index'] , resolve)
		},
		{
			path: '/index/setting',
			name: '系统设置',
			meta:{
				title: '系统设置'
			},
			component: resolve=>require(['@/view/home/setting/Index'] , resolve)
		},

		{
			path: '/mall/index',
			name: '商城',
			meta:{
				title: '商城'
			},
			component: resolve=>require(['@/view/mall/index/Index'] , resolve)
		},
		{
			path: '/mall/product',
			name: '商品管理',
			meta:{
				title: '商品管理'
			},
			component: resolve=>require(['@/view/mall/product/index/Index'] , resolve)
		},
		{
			path: '/mall/category',
			name: '商品分类',
			meta:{
				title: '商品分类'
			},
			component: resolve=>require(['@/view/mall/product/category/Index'] , resolve)
		},
		{
			path: '/mall/spec',
			name: '规格模板',
			meta:{
				title: '规格模板'
			},
			component: resolve=>require(['@/view/mall/product/spec/Index'] , resolve)
		},
		{
			path: '/mall/param',
			name: '参数模板',
			meta:{
				title: '参数模板'
			},
			component: resolve=>require(['@/view/mall/product/param/Index'] , resolve)
		},
		{
			path: '/mall/source',
			name: '素材管理',
			meta:{
				title: '素材管理'
			},
			component: resolve=>require(['@/view/mall/product/source/Index'] , resolve)
		},
		{
			path: '/mall/hot',
			name: '热搜商品',
			meta:{
				title: '热搜商品'
			},
			component: resolve=>require(['@/view/mall/product/hot/Index'] , resolve)
		},
		{
			path: '/mall/order',
			name: '订单管理',
			meta:{
				title: '订单管理'
			},
			component: resolve=>require(['@/view/mall/order/index/Index'] , resolve)
		},
		{
			path: '/mall/server',
			name: '售后订单',
			meta:{
				title: '售后订单'
			},
			component: resolve=>require(['@/view/mall/order/server/Index'] , resolve)
		},
		{
			path: '/mall/express',
			name: '发货管理',
			meta:{
				title: '发货管理'
			},
			component: resolve=>require(['@/view/mall/order/express/Index'] , resolve)
		},
		{
			path: '/mall/comment',
			name: '评论管理',
			meta:{
				title: '评论管理'
			},
			component: resolve=>require(['@/view/mall/order/comment/Index'] , resolve)
		},
		{
			path: '/mall/shop',
			name: '导航图标',
			meta:{
				title: '导航图标'
			},
			component: resolve=>require(['@/view/mall/shop/index/Index'] , resolve)
		},
		{
			path: '/mall/shop/banner',
			name: '焦点图',
			meta:{
				title: '焦点图'
			},
			component: resolve=>require(['@/view/mall/shop/banner/Index'] , resolve)
		},
		{
			path: '/mall/shop/ad',
			name: '开屏广告',
			meta:{
				title: '开屏广告'
			},
			component: resolve=>require(['@/view/mall/shop/ad/Index'] , resolve)
		},
		{
			path: '/mall/shop/theme',
			name: '商城风格',
			meta:{
				title: '商城风格'
			},
			component: resolve=>require(['@/view/mall/shop/theme/Index'] , resolve)
		},
		{
			path: '/mall/plugin',
			name: '全部应用',
			meta:{
				title: '全部应用'
			},
			component: resolve=>require(['@/view/mall/plugin/index/Index'] , resolve)
		},
		{
			path: '/mall/platform',
			name: '销售渠道',
			meta:{
				title: '销售渠道'
			},
			component: resolve=>require(['@/view/mall/plugin/platform/Index'] , resolve)
		},
		{
			path: '/mall/promotion',
			name: '促销玩法',
			meta:{
				title: '促销玩法'
			},
			component: resolve=>require(['@/view/mall/plugin/promotion/Index'] , resolve)
		},
		{
			path: '/mall/acquisition',
			name: '获客工具',
			meta:{
				title: '获客工具'
			},
			component: resolve=>require(['@/view/mall/plugin/acquisition/Index'] , resolve)
		},
		{
			path: '/mall/coupon',
			name: '优惠券',
			meta:{
				title: '优惠券'
			},
			component: resolve=>require(['@/view/mall/plugin/coupon/Index'] , resolve)
		},
		{
			path: '/mall/integral',
			name: '积分管理',
			meta:{
				title: '积分管理'
			},
			component: resolve=>require(['@/view/mall/plugin/integral/Index'] , resolve)
		},
		{
			path: '/mall/integral_mall',
			name: '积分商城',
			meta:{
				title: '积分商城'
			},
			component: resolve=>require(['@/view/mall/plugin/integral_mall/Index'] , resolve)
		},
		{
			path: '/mall/full_reduction',
			name: '满减设置',
			meta:{
				title: '满减设置'
			},
			component: resolve=>require(['@/view/mall/plugin/full_reduction/Index'] , resolve)
		},
		{
			path: '/mall/setting',
			name: '商城设置',
			meta:{
				title: '商城设置'
			},
			component: resolve=>require(['@/view/mall/setting/Index'] , resolve)
		},
		{
			path: '/mall/setting/goods',
			name: '商品设置',
			meta:{
				title: '商品设置'
			},
			component: resolve=>require(['@/view/mall/setting/Goods'] , resolve)
		},
		{
			path: '/mall/setting/pay',
			name: '支付设置',
			meta:{
				title: '支付设置'
			},
			component: resolve=>require(['@/view/mall/setting/Pay'] , resolve)
		},
		{
			path: '/mall/setting/message',
			name: '消息设置',
			meta:{
				title: '消息设置'
			},
			component: resolve=>require(['@/view/mall/setting/Message'] , resolve)
		},
		{
			path: '/mall/setting/express',
			name: '物流设置',
			meta:{
				title: '物流设置'
			},
			component: resolve=>require(['@/view/mall/setting/Express'] , resolve)
		},
		{
			path: '/mall/setting/upload',
			name: '上传设置',
			meta:{
				title: '上传设置'
			},
			component: resolve=>require(['@/view/mall/setting/Upload'] , resolve)
		},
		{
			path: '/user/index',
			name: '会员',
			meta:{
				title: '会员'
			},
			component: resolve=>require(['@/view/user/index/Index'] , resolve)
		},
		{
			path: '/user/list',
			name: '会员管理',
			meta:{
				title: '会员管理'
			},
			component: resolve=>require(['@/view/user/index/List'] , resolve)
		},
		{
			path: '/user/group',
			name: '会员等级',
			meta:{
				title: '会员等级'
			},
			component: resolve=>require(['@/view/user/group/Index'] , resolve)
		},
		{
			path: '/user/buyer',
			name: '会员购买',
			meta:{
				title: '会员购买'
			},
			component: resolve=>require(['@/view/user/buyer/Index'] , resolve)
		},
		{
			path: '/user/balance',
			name: '会员余额',
			meta:{
				title: '会员余额'
			},
			component: resolve=>require(['@/view/user/balance/Index'] , resolve)
		},
		{
			path: '/user/integral',
			name: '会员积分',
			meta:{
				title: '会员积分'
			},
			component: resolve=>require(['@/view/user/integral/Index'] , resolve)
		},
		{
			path: '/user/blacklist',
			name: '黑名单',
			meta:{
				title: '黑名单'
			},
			component: resolve=>require(['@/view/user/blacklist/Index'] , resolve)
		},
		{
			path: '/user/behavior',
			name: '用户行为',
			meta:{
				title: '用户行为'
			},
			component: resolve=>require(['@/view/user/behavior/Index'] , resolve)
		},
		{
			path: '/store/index',
			name: '分销',
			meta:{
				title: '分销'
			},
			component: resolve=>require(['@/view/store/index/Index'] , resolve)
		},
		{
			path: '/store/list',
			name: '分销员',
			meta:{
				title: '分销员'
			},
			component: resolve=>require(['@/view/store/index/List'] , resolve)
		},
		{
			path: '/store/order',
			name: '分销订单',
			meta:{
				title: '分销订单'
			},
			component: resolve=>require(['@/view/store/order/Index'] , resolve)
		},
		{
			path: '/store/setting',
			name: '分销设置',
			meta:{
				title: '分销设置'
			},
			component: resolve=>require(['@/view/store/setting/Index'] , resolve)
		},
		{
			path: '/store/cash',
			name: '提现记录',
			meta:{
				title: '提现记录'
			},
			component: resolve=>require(['@/view/store/cash/Index'] , resolve)
		},
		{
			path: '/store/log',
			name: '佣金流水',
			meta:{
				title: '佣金流水'
			},
			component: resolve=>require(['@/view/store/log/Index'] , resolve)
		},
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js